import { observable, makeObservable, makeAutoObservable } from 'mobx';
import {DomainStore, DomainObject} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {redirect} from 'shared/tools';
import qs from 'qs';

class SignUpForm extends DomainObject {
  email;
  emailConfirmation;
  password;
  invite;
  token;

  constructor(other) {
    super();

    makeObservable(this, {
      email: observable,
      emailConfirmation: observable,
      password: observable,
      invite: observable,
      token: observable
    });

    this.merge(other);
  }
}

class ValidateSignupForm extends DomainObject {
  lastName;
  birthDate;
  token;

  _relations = {
    _dates: ['birthDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      lastName: observable,
      birthDate: observable,
      token: observable
    });

    this.merge(other);
  }
}

class EmployeeSignupState {
  store = new DomainStore();
  history;
  match;

  form = new SignUpForm();
  errors = {};
  invitationValidated = false;
  validateSignupForm = new ValidateSignupForm();
  validateSignupFormErrors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;
  }

  async load() {
    const token = qs.parse(location.search.replace('?', ''))['token'];

    await this.store._compose([
      endpoints.USER_INVITATIONS.FIND_INVITATION.with(token)
    ]);
    this.invite = this.store._getSingle(
      types.USER_INVITATION
    );
    this.form.merge({token});
  }

  async signUp() {
    const {model, errors} = await this.store.post(
      endpoints.USER_INVITATIONS.SIGNUP,
      types.USER,
      this.form
    );
    this.errors = errors;

    if (model) {
      return redirect('/');
    }

    return null;
  }

  async validateInvite() {
    this.validateSignupForm.merge({token: this.form.token});

    const {model, errors} = await this.store.post(
      endpoints.USER_INVITATIONS.VALIDATE_INVITATION,
      types.INVITATION_VALIDATION,
      this.validateSignupForm
    );
    this.validateSignupFormErrors = errors;

    if (model) {
      this.invitationValidated = true;
    }

    return null;
  }

  get birthDateRequired() {
    return this.invite.birthDateRequired;
  }

  get authenticityToken() {
    return document.getElementsByName('csrf-token')[0].content;
  }
}

export default EmployeeSignupState;
